'use client'

import dynamic from 'next/dynamic'
import type { ReactElement } from 'react'
import type { FieldValues } from 'react-hook-form'

import type { FormProperties } from '~/core/ui/Form'

export const DynamicImportForm = dynamic(
  () => import('~/core/ui/Form').then((res) => res.Form),
  {
    ssr: false
  }
) as <TFieldValues extends FieldValues = FieldValues>(
  props: FormProperties<TFieldValues>
) => ReactElement<any>
